<!--
 * @Descripttion: 数据表格组件
 * @version: 1.10
 * @Author: sakuya
 * @Date: 2021年11月29日21:51:15
 * @LastEditors: sakuya
 * @LastEditTime: 2022年6月4日17:35:26
-->

<template>
  <div class="scTable" :style="{ height: _height }" ref="scTableMain" v-loading="loading">
    <div class="scTable-table" :style="{ height: _table_height }">
      <el-table
        v-bind="$attrs"
        :data="tableData"
        :row-key="rowKey"
        :key="toggleIndex"
        ref="scTable"
        :height="height == 'auto' ? null : '100%'"
        :size="config.size"
        :border="config.border"
        :stripe="config.stripe"
        :span-method="
          (e) => {
            return objectSpanMethod(e, tableData)
          }
        "
        :show-summary="showSummary"
        :summary-method="remoteSummary ? remoteSummaryMethod : summaryMethod"
        :show-overflow-tooltip="true"
        @sort-change="sortChange"
        @filter-change="filterChange"
        @selection-change="changeSelection"
        @select-all="changeSelection"
        @dels="dels"
      >
        <slot></slot>
        <el-table-column v-if="showSelection" type="selection" width="55" />
        <template v-for="(item, index) in userColumn" :key="index">
          <el-table-column
            v-if="!item.hide"
            :column-key="item.prop"
            :label="item.label"
            :prop="item.prop"
            :width="item.width || 150"
            :sortable="item.sortable"
            :fixed="item.fixed"
            :filters="item.filters"
            :filter-method="remoteFilter || !item.filters ? null : filterHandler"
            :tooltip-formatter="item?.options?.tooltipFormatter"
            :show-overflow-tooltip="item.showOverflowTooltip"
            :align="item.align || 'center'"
          >
            <template #default="scope">
              <slot v-if="item.type == 'icon'">
                <el-icon size="32">
                  <component :is="scope.row.icon" />
                </el-icon>
              </slot>
              <slot v-else-if="item.type == 'image'">
                <el-image
                  :src="(typeof item.render == 'function' && item.render(scope.row)) || scope.row[item.prop].split(',')[0]"
                  preview-teleported
                  :preview-src-list="scope.row[item.prop]?.split(',')"
                  fit="cover"
                  :style="item.options?.style || { width: '100px', height: '100px' }"
                />
              </slot>
              <slot v-else-if="item.type == 'switch'">
                <el-switch
                  :disabled="item.options.disabled"
                  v-model="scope.row[item.prop]"
                  style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"
                  :active-value="item.options?.activeValue || 1"
                  :inactive-value="item.options?.inactiveValue || 0"
                  :active-text="item.options?.activeText || ''"
                  :inactive-text="item.options?.inactiveText || ''"
                  @click="item?.options?.change && item.options?.change(scope.row)"
                />
              </slot>
              <slot v-else-if="item?.options?.remote && item.options.remote.api">
                <el-tag v-if="item.type == 'tag'" :type="getLabel($store.state.dicData.dicData.get(item.options?.remote?.api), scope.row[item.prop], item.options.props, 'showTypeValue') || 'primary'"
                  >{{ getLabel($store.state.dicData.dicData.get(item.options?.remote?.api), scope.row[item.prop], item.options.props) }}
                </el-tag>
                <span v-else>
                  {{ getLabel($store.state.dicData.dicData.get(item.options?.remote?.api), scope.row[item.prop], item.options.props) }}
                </span>
                <!-- {{ getLabel($store.state.dicData.dicData.get(item.options?.remote?.api), scope.row[item.prop]) }} -->
              </slot>
              <slot v-else-if="typeof item.render == 'function'">
                <el-tag v-if="item.type == 'tag'" :type="item.render(scope.row).type">{{ item.render(scope.row).text }}</el-tag>
                <div v-else v-html="item.render(scope.row)"></div>
                <!-- <el-image :src="scope.row[item.prop]" /> -->
                <!-- {{ item.render(scope.row) }} -->
              </slot>

              <slot v-else :name="item.prop" v-bind="scope">
                <el-tag
                  v-if="item.type == 'tag' && item.options?.remote"
                  :type="getLabel($store.state.dicData.dicData.get(item.options?.remote?.api), scope.row[item.prop], item.options.props, 'showTypeValue') || 'primary'"
                >
                  {{ getLabel($store.state.dicData.dicData.get(item.options?.remote?.api), scope.row[item.prop], item.options.props) }}
                </el-tag>
                <el-tag v-else-if="item.type == 'tag'"> {{ scope.row[item.prop] }}</el-tag>
                <el-text v-else>{{ scope.row[item.prop] }}</el-text>
              </slot>
            </template>
          </el-table-column>
        </template>
        <el-table-column min-width="1"></el-table-column>
        <template #empty>
          <el-empty :description="emptyText" :image-size="100"></el-empty>
        </template>
      </el-table>
    </div>
    <div class="scTable-page" v-if="!hidePagination || !hideDo">
      <div class="scTable-pagination">
        <el-pagination
          v-if="!hidePagination"
          background
          :small="true"
          :layout="paginationLayout"
          :total="total"
          :page-size="scPageSize"
          :page-sizes="pageSizes"
          v-model:currentPage="currentPage"
          @current-change="paginationChange"
          @update:page-size="pageSizeChange"
        ></el-pagination>
      </div>
      <div class="scTable-do" v-if="!hideDo">
        <el-button v-if="!hideRefresh" @click="refresh" icon="el-icon-refresh" circle style="margin-left: 15px"></el-button>
        <el-popover v-if="column" placement="top" title="列设置" :width="500" trigger="click" :hide-after="0" @show="customColumnShow = true" @after-leave="customColumnShow = false">
          <template #reference>
            <el-button icon="el-icon-set-up" circle style="margin-left: 15px"></el-button>
          </template>
          <columnSetting v-if="customColumnShow" ref="columnSetting" @userChange="columnSettingChange" @save="columnSettingSave" @back="columnSettingBack" :column="userColumn"></columnSetting>
        </el-popover>
        <el-popover v-if="!hideSetting" placement="top" title="表格设置" :width="400" trigger="click" :hide-after="0">
          <template #reference>
            <el-button icon="el-icon-setting" circle style="margin-left: 15px"></el-button>
          </template>
          <el-form label-width="80px" label-position="left">
            <el-form-item label="表格尺寸">
              <el-radio-group v-model="config.size" size="small" @change="configSizeChange">
                <el-radio-button label="large">大</el-radio-button>
                <el-radio-button label="default">正常</el-radio-button>
                <el-radio-button label="small">小</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="样式">
              <el-checkbox v-model="config.border" label="纵向边框"></el-checkbox>
              <el-checkbox v-model="config.stripe" label="斑马纹"></el-checkbox>
            </el-form-item>
          </el-form>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config/table"
import columnSetting from "./columnSetting"
import { ElIcon } from "element-plus"
import http from "@/utils/request"
import store from "@/store"
export default {
  name: "scTable",
  components: {
    columnSetting,
    ElIcon
  },
  props: {
    tableName: { type: String, default: "" },
    apiObj: { type: Object, default: () => {} },
    params: { type: Object, default: () => ({}) },
    data: { type: Object, default: () => {} },
    height: { type: [String, Number], default: "100%" },
    size: { type: String, default: "default" },
    border: { type: Boolean, default: false },
    stripe: { type: Boolean, default: false },
    pageSize: { type: Number, default: config.pageSize },
    pageSizes: { type: Array, default: config.pageSizes },
    rowKey: { type: String, default: "" },
    summaryMethod: { type: Function, default: null },
    column: { type: Object, default: () => {} },
    remoteSort: { type: Boolean, default: false },
    remoteFilter: { type: Boolean, default: false },
    remoteSummary: { type: Boolean, default: false },
    objectSpanMethod: { type: Function, default: () => {}, require: false },
    showSummary: { type: Boolean, default: false },
    hidePagination: { type: Boolean, default: false },
    hideDo: { type: Boolean, default: false },
    hideRefresh: { type: Boolean, default: false },
    hideSetting: { type: Boolean, default: false },
    showSelection: { type: Boolean, default: true },
    selectkey: { type: String, default: "id" },
    paginationLayout: { type: String, default: config.paginationLayout },
    delMsg: { type: String, default: "是否移除该条数据 ?" },
    delText: { type: String, default: "删除" }
  },
  emits: ["changeSelection", "dataChange"],
  watch: {
    //监听从props里拿到值了
    data() {
      this.tableData = this.data
      this.total = this.tableData.length
    },
    // apiObj() {
    //   // this.tableParams = this.params
    //   // this.refresh()
    // },
    column() {
      this.userColumn = this.column
    }
  },
  computed: {
    _height() {
      return Number(this.height) ? Number(this.height) + "px" : this.height
    },
    _table_height() {
      return this.hidePagination && this.hideDo ? "100%" : "calc(100% - 50px)"
    }
  },
  data() {
    return {
      scPageSize: this.pageSize,
      isActivat: true,
      emptyText: "暂无数据",
      toggleIndex: 0,
      tableData: [],
      total: 0,
      beforePage: 0,
      currentPage: 1,
      prop: null,
      order: null,
      loading: false,
      tableHeight: "100%",
      tableParams: this.params,
      userColumn: [],
      customColumnShow: false,
      summary: {},
      config: {
        size: this.size,
        border: this.border,
        stripe: this.stripe
      },
      selectRows: [],
      selectIds: []
    }
  },
  async mounted() {
    //判断是否开启自定义列
    if (this.column) {
      this.getCustomColumn()
    } else {
      this.userColumn = this.column
    }
    //判断是否静态数据
    if (this.apiObj) {
      await this.getData()
    } else if (this.data) {
      this.tableData = this.data
      this.total = this.tableData.length
    }
  },
  activated() {
    if (!this.isActivat) {
      this.$refs.scTable.doLayout()
    }
  },
  deactivated() {
    this.isActivat = false
  },
  methods: {
    getLabel(data, value, props, key) {
      // console.log('==============', data, value, props)
      const res = this.$TOOL.getLabel(data, value, props)
      if (res) {
        if (key) {
          return res[key]
        } else {
          return res[props.label] ? res[props.label] : value
        }
      }

      return res
    },
    getRemoteData() {
      let remoteData = []
      this.userColumn.forEach((item) => {
        if (item.options && item.options.remote) {
          if (store._state.data.dicData.dicData.has(item.options.remote.api)) {
            return
          }
          let req = http.get(item.options.remote.api, item.options.remote.data).then((res) => {
            let data = res.data.records || res.data || []
            item.options.items = this.$TOOL.filterTree(data, item.options.props)
            store._state.data.dicData.dicData.set(item.options.remote.api, data)
            // console.log(11, res.data, item.options.items)
          })
          remoteData.push(req)
        }
      })
      Promise.all(remoteData).then(() => {
        this.loading = false
      })
      // console.log("==========", store._state.data)
    },
    //获取列
    async getCustomColumn() {
      const userColumn = await config.columnSettingGet(this.tableName, this.column)
      this.userColumn = userColumn
      this.getRemoteData()
    },
    //获取数据
    async getData() {
      this.loading = true
      let reqData = {
        [config.request.page]: this.currentPage,
        [config.request.pageSize]: this.scPageSize
        // [config.request.prop]: this.prop,
        // [config.request.order]: this.order
      }
      if (this.hidePagination) {
        delete reqData[config.request.page]
        delete reqData[config.request.pageSize]
      }
      this.tableParams = this.params
      Object.assign(reqData, this.tableParams)
      try {
        var res = await this.apiObj.get(reqData)
        if (res.success) {
          this.beforePage = this.currentPage
          // console.log("222", res, this.apiObj)
          this.tableData = res.data.records || res.data || []
          // console.log("tableData", this.tableData)
          this.total = res.data.total || res.data.length
          res.data = this.tableData
        }
      } catch (error) {
        this.loading = false
        this.emptyText = error.statusText
        return false
      }
      try {
        var response = config.parseData(res)
      } catch (error) {
        this.loading = false
        this.emptyText = "数据格式错误"
        return false
      }
      if (response.code != config.successCode) {
        this.loading = false
        this.emptyText = response.msg
      } else {
        this.emptyText = "暂无数据"
        if (this.hidePagination) {
          this.tableData = response.data.records || res.data || []
        } else {
          this.tableData = response.data.records || res.data || []
        }
        this.summary = response.summary || {}
        this.loading = false
      }
      this.$emit("dataChange", res, this.tableData)
    },
    beforeDel() {
      return this.$confirm(`${this.delMsg}`, "提示", {
        type: "warning"
      })
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })
    },
    async dels() {
      this.beforeDel().then(async (flag) => {
        if (flag) {
          const res = await this.apiObj.del({ ids: this.selectIds })
          if (res.success) {
            await this.getData()
            this.$message.success("删除成功")
          }
        }
      })
    },
    //分页点击
    async paginationChange() {
      if (this.currentPage == this.beforePage) {
        return (this.loading = false)
      }
      await this.getData()
    },
    //条数变化
    async pageSizeChange(size) {
      this.scPageSize = size
      await this.getData()
    },
    //刷新数据
    async refresh() {
      this.$refs.scTable.clearSelection()
      await this.getData()
    },
    //更新数据 合并上一次params
    async upData(params, page = 1) {
      this.currentPage = page
      this.$refs.scTable.clearSelection()
      Object.assign(this.tableParams, params || {})
      await this.getData()
    },
    //重载数据 替换params
    async reload(params, page = 1) {
      this.currentPage = page
      this.tableParams = params || {}
      this.$refs.scTable.clearSelection()
      this.$refs.scTable.clearSort()
      this.$refs.scTable.clearFilter()
      await this.getData()
    },
    //自定义变化事件
    columnSettingChange(userColumn) {
      this.userColumn = userColumn
      this.toggleIndex += 1
    },
    //自定义列保存
    async columnSettingSave(userColumn) {
      this.$refs.columnSetting.isSave = true
      try {
        await config.columnSettingSave(this.tableName, userColumn)
      } catch (error) {
        this.$message.error("保存失败")
        this.$refs.columnSetting.isSave = false
      }
      this.$message.success("保存成功")
      this.$refs.columnSetting.isSave = false
    },
    //自定义列重置
    async columnSettingBack() {
      this.$refs.columnSetting.isSave = true
      try {
        const column = await config.columnSettingReset(this.tableName, this.column)
        this.userColumn = column
        this.$refs.columnSetting.usercolumn = JSON.parse(JSON.stringify(this.userColumn || []))
      } catch (error) {
        this.$message.error("重置失败")
        this.$refs.columnSetting.isSave = false
      }
      this.$refs.columnSetting.isSave = false
    },
    //排序事件
    async sortChange(obj) {
      if (!this.remoteSort) {
        return false
      }
      if (obj.column && obj.prop) {
        this.prop = obj.prop
        this.order = obj.order
      } else {
        this.prop = null
        this.order = null
      }
      await this.getData()
    },
    //本地过滤
    filterHandler(value, row, column) {
      const property = column.property
      return row[property] === value
    },
    //过滤事件
    filterChange(filters) {
      if (!this.remoteFilter) {
        return false
      }
      Object.keys(filters).forEach((key) => {
        filters[key] = filters[key].join(",")
      })
      this.upData(filters)
    },
    //远程合计行处理
    remoteSummaryMethod(param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计"
          return
        }
        const values = this.summary[column.property]
        if (values) {
          sums[index] = values
        } else {
          sums[index] = ""
        }
      })
      return sums
    },
    configSizeChange() {
      this.$refs.scTable.doLayout()
    },
    //插入行 unshiftRow
    unshiftRow(row) {
      this.tableData.unshift(row)
    },
    //插入行 pushRow
    pushRow(row) {
      this.tableData.push(row)
    },
    //根据key覆盖数据
    updateKey(row, rowKey = this.rowKey) {
      this.tableData
        .filter((item) => item[rowKey] === row[rowKey])
        .forEach((item) => {
          Object.assign(item, row)
        })
    },
    //根据index覆盖数据
    updateIndex(row, index) {
      Object.assign(this.tableData[index], row)
    },
    //根据index删除
    removeIndex(index) {
      this.tableData.splice(index, 1)
    },
    //根据index批量删除
    removeIndexes(indexes = []) {
      indexes.forEach((index) => {
        this.tableData.splice(index, 1)
      })
    },
    //根据key删除
    removeKey(key, rowKey = this.rowKey) {
      this.tableData.splice(
        this.tableData.findIndex((item) => item[rowKey] === key),
        1
      )
    },
    //根据keys批量删除
    removeKeys(keys = [], rowKey = this.rowKey) {
      keys.forEach((key) => {
        this.tableData.splice(
          this.tableData.findIndex((item) => item[rowKey] === key),
          1
        )
      })
    },
    //原生方法转发
    clearSelection() {
      this.$refs.scTable.clearSelection()
    },
    changeSelection(rows) {
      this.selectRows = rows
      this.selectIds = rows?.map((item) => item[this.selectkey])
      // console.log(11, this.selectIds)
      this.$emit("changeSelection", this.selectIds)
    },

    toggleAllSelection() {
      this.$refs.scTable.toggleAllSelection()
    },
    toggleRowExpansion(row, expanded) {
      this.$refs.scTable.toggleRowExpansion(row, expanded)
    },
    setCurrentRow(row) {
      this.$refs.scTable.setCurrentRow(row)
    },
    clearSort() {
      this.$refs.scTable.clearSort()
    },
    clearFilter(columnKey) {
      this.$refs.scTable.clearFilter(columnKey)
    },
    doLayout() {
      this.$refs.scTable.doLayout()
    },
    sort(prop, order) {
      this.$refs.scTable.sort(prop, order)
    }
  }
}
</script>

<style scoped>
.scTable {
}

.scTable-table {
  height: calc(100% - 50px);
}

.scTable-page {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.scTable-do {
  white-space: nowrap;
}

.scTable:deep(.el-table__footer) .cell {
  font-weight: bold;
}

.scTable:deep(.el-table__body-wrapper) .el-scrollbar__bar.is-horizontal {
  height: 12px;
  border-radius: 12px;
}

.scTable:deep(.el-table__body-wrapper) .el-scrollbar__bar.is-vertical {
  width: 12px;
  border-radius: 12px;
}
</style>
